<template>
    <van-popup v-model="show" :footer="null" :closable="false" :destroyOnClose="true" :maskClosable="true"  get-container="body">
        <div class="ht-dialog-video" v-if="show">
            <div class="close-box">
            <img class="close-icon" :src="closeIcon" @click="close" />
            </div>
            <div class="video-box">
                <video class="video" ref="video" :src="src" :controls="isPlay" @play="play"  @seeking="seeking" @seeked="seeked" @pause="pause" :poster="poster"></video>
                <img class="play-icon" v-if="!isPlay" :src="playIcon" @click="playVideo"/>
            </div>
        </div>
    </van-popup>
</template>

<script>
    import playIcon from '@/assets/images/newStudyChinese/play_icon.svg'
    import closeIcon from '@/assets/newPromotionImg/close.svg'
    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            },
            src: {
                type: String,
                default: ''
            },
            // 封面
            poster: {
                type: String,
                defualt: ''
            },
        },
        data(){
            return {
                playIcon,
                closeIcon,
                isPlay: false
            }
        },

        watch: {
            show(){
                if(this.show){
                    this.$nextTick(() => {{
                        this.playVideo()
                    }})
                }
            }
        },

        methods: {
            playVideo (){
                this.$refs.video && this.$refs.video.play()
            },

            play(){
                this.isPlay = true
            },

            seeking(){
                this.isPlay = true
            },

            seeked(){
                console.log(3)
            },

            pause(e){
                this.isPlay = false
            },

            close(){
                this.$emit('close')
            }
        }
    }
</script>

<style lang="scss">
    .ht-dialog-video {
        .close-box {
            width: 100%;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background-color: #000;

            .close-icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
                margin-right: 16px;
            }
        }

        .video-box {
            width: 90vw;
            height: auto;
            position: relative;

            .video {
                display: block;
                width: 100%;
                height: auto;
                object-fit: cover;
            }

            .play-icon {
                width: 15%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                cursor: pointer;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/HtDialogVideo/index.vue